import React from 'react'

export const renderPaginationNumbers = (
  currentPage: number,
  totalPages: number,
  onPageChange: (page: number) => void
): React.ReactNode => {
  const pages = []
  const showEllipsis = totalPages > 7

  if (!showEllipsis) {
    // Toplam sayfa sayısı az ise hepsini göster
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }
  } else {
    // İlk sayfa her zaman görünür
    pages.push(1)

    if (currentPage > 3) {
      pages.push('...')
    }

    // Mevcut sayfanın etrafındaki sayfaları göster
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(currentPage + 1, totalPages - 1); i++) {
      pages.push(i)
    }

    if (currentPage < totalPages - 2) {
      pages.push('...')
    }

    // Son sayfa her zaman görünür
    if (totalPages > 1) {
      pages.push(totalPages)
    }
  }

  return (
    <div className="pagination-numbers">
      {pages.map((page, index) => (
        page === '...' ? (
          <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
        ) : (
          <button
            key={page}
            className={`pagination-number ${currentPage === page ? "active" : ""}`}
            onClick={() => onPageChange(page as number)}
          >
            {page}
          </button>
        )
      ))}
    </div>
  )
}

export const calculatePaginationDetails = (
  currentPage: number,
  pageSize: number,
  totalRecords: number
) => {
  const start = currentPage * pageSize - pageSize + 1
  const end = Math.min(currentPage * pageSize, totalRecords)
  
  return {
    start,
    end,
    totalRecords
  }
} 